import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { ChangeCoverageFeatureFacade } from '@amfam/policy/change-coverage/feature';
import { PolicySelectors } from '@amfam/policy/data-access';
import { RiskModel } from '@amfam/policy/models';
import { FEATURES, VehicleCoveragesFacade } from '@amfam/policy/vehicle-coverages/data-access';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { DockingBarService, LoadingSpinnerService } from '@amfam/ui-kit';

@Component({
  selector: 'amfam-agent-help',
  templateUrl: './agent-help.component.html',
  styleUrls: ['./agent-help.component.scss'],
  standalone: false
})
export class AgentHelpComponent implements OnInit {
  isPartner: boolean;
  showVehicleInfo = false;
  public vehicle$: Observable<RiskModel> = this.store
    .select(PolicySelectors.selectAutoPolicyById(this.route.snapshot.paramMap.get('id')))
    .pipe(tap(vehicle => (vehicle ? this.spinnerService.stop() : '')));
  public vehicleId: string;
  isPartner$: Observable<boolean> = this.store.select(BrandSelectors.selectIsPartner);

  constructor(
    private route: ActivatedRoute,
    private spinnerService: LoadingSpinnerService,
    private dockingBarService: DockingBarService,
    private store: Store,
    public vehicleFacade: VehicleCoveragesFacade,
    public changeCoverageFeatureFacade: ChangeCoverageFeatureFacade
  ) {
    this.store
      .select(BrandSelectors.selectIsPartner)
      .pipe(first())
      .subscribe(isPartner => {
        this.isPartner = isPartner;
      });
  }

  ngOnInit(): void {
    this.dockingBarService.registerHeading('UPDATE MY COVERAGE');
    this.vehicleId = this.route.snapshot.paramMap.get('id');
    if (this.isPartner) {
      this.changeCoverageFeatureFacade.sendAnalytics({
        event: FEATURES.CHANGE,
        pageAnalyticName: 'NeedAgent'
      });
    } else {
      this.changeCoverageFeatureFacade.sendAnalytics({
        event: FEATURES.CHANGE,
        pageAnalyticName: 'Quote:NeedAgent'
      });
    }
  }

  sendToAgent() {
    this.spinnerService.start({ blockActions: true });
    this.changeCoverageFeatureFacade.sendToAgent(this.vehicleId);
    if (!this.isPartner) {
      this.changeCoverageFeatureFacade.sendAnalytics({
        buttonAnalyticName: 'Quote:NeedAgent:SendToAgent',
        event: FEATURES.CHANGE
      });
    }
  }

  goBackOneStep() {
    this.store.dispatch(fromRouterActions.Back());
  }

  cancel() {
    if (!this.isPartner) {
      this.changeCoverageFeatureFacade.sendAnalytics({
        buttonAnalyticName: 'Quote:NeedAgent:Cancel',
        event: FEATURES.CHANGE
      });
    }
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/overview']
      })
    );
  }
}
